'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutCluster } from 'design-system/client';
import { useTranslations } from 'next-intl';
import type { CSSProperties } from 'react';
import ScreenName from '../ScreenName';
import WidgetHeadline from '../WidgetHeadline';
type HeadlineProps = {
  headlineFont: string;
  headlineFontColor: string;
  headlineFontSize: number;
  headlineFontWeight: number;
} | {
  headlineFont: string;
  headlineFontWeight: number;
  headlineFontColor: string;
  headlineFontSize?: undefined;
};
type DataProps = {
  screenNameFont: string;
  screenNameFontColor: string;
  screenNameFontSize: number;
  screenNameFontWeight: number;
} | {
  screenNameFont: string;
  screenNameFontColor: string;
  screenNameFontSize?: undefined;
  screenNameFontWeight?: undefined;
};
function Unstyled(t0) {
  const $ = _c(55);
  const {
    headlineClassNames,
    headlineProps,
    headlineFontStyle,
    dataStyle,
    totalDonationAmount,
    lastDonationDonor,
    lastDonationAmount,
    topDonationDonor,
    topDonationAmount,
    dataProps
  } = t0;
  const t = useTranslations("nextjs.streambot");
  let t1;
  if ($[0] !== t) {
    t1 = t("total_headline");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== headlineFontStyle || $[3] !== headlineProps || $[4] !== t1) {
    t2 = <WidgetHeadline content={t1} {...headlineProps} style={headlineFontStyle} />;
    $[2] = headlineFontStyle;
    $[3] = headlineProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== dataStyle || $[7] !== totalDonationAmount) {
    t3 = <div className="data-container"><span style={dataStyle}>{totalDonationAmount}</span></div>;
    $[6] = dataStyle;
    $[7] = totalDonationAmount;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== headlineClassNames || $[10] !== t2 || $[11] !== t3) {
    t4 = <div className={headlineClassNames}>{t2}{t3}</div>;
    $[9] = headlineClassNames;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("standard.last_donation");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== headlineFontStyle || $[16] !== headlineProps || $[17] !== t5) {
    t6 = <WidgetHeadline content={t5} {...headlineProps} style={headlineFontStyle} />;
    $[15] = headlineFontStyle;
    $[16] = headlineProps;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== dataProps || $[20] !== lastDonationDonor) {
    t7 = <ScreenName authorName={lastDonationDonor} {...dataProps} />;
    $[19] = dataProps;
    $[20] = lastDonationDonor;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== dataStyle || $[23] !== lastDonationAmount) {
    t8 = <div style={dataStyle}>{lastDonationAmount}</div>;
    $[22] = dataStyle;
    $[23] = lastDonationAmount;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <div className="data-container">{t7}{t8}</div>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== headlineClassNames || $[29] !== t6 || $[30] !== t9) {
    t10 = <div className={headlineClassNames}>{t6}{t9}</div>;
    $[28] = headlineClassNames;
    $[29] = t6;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t) {
    t11 = t("standard.top_donation");
    $[32] = t;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== headlineFontStyle || $[35] !== headlineProps || $[36] !== t11) {
    t12 = <WidgetHeadline content={t11} {...headlineProps} style={headlineFontStyle} />;
    $[34] = headlineFontStyle;
    $[35] = headlineProps;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== dataProps || $[39] !== topDonationDonor) {
    t13 = <ScreenName authorName={topDonationDonor} {...dataProps} />;
    $[38] = dataProps;
    $[39] = topDonationDonor;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== dataStyle || $[42] !== topDonationAmount) {
    t14 = <div style={dataStyle}>{topDonationAmount}</div>;
    $[41] = dataStyle;
    $[42] = topDonationAmount;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t13 || $[45] !== t14) {
    t15 = <div className="data-container">{t13}{t14}</div>;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== headlineClassNames || $[48] !== t12 || $[49] !== t15) {
    t16 = <div className={headlineClassNames}>{t12}{t15}</div>;
    $[47] = headlineClassNames;
    $[48] = t12;
    $[49] = t15;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t10 || $[52] !== t16 || $[53] !== t4) {
    t17 = <LayoutCluster justify="start" className="display-container standard" space="700"><div className="standard-inner-wrapper">{t4}{t10}{t16}</div></LayoutCluster>;
    $[51] = t10;
    $[52] = t16;
    $[53] = t4;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  return t17;
}
export default Unstyled;